<template>
  <div>
    <ul>
      <li v-for="item in items" :key="item.id">
        <img :src="item.preview_src" alt="" @click="showPhotoId = item.id">
      </li>
    </ul>
    <photo-modal :photo-id="showPhotoId" @close="showPhotoId = null"></photo-modal>
  </div>
</template>
<script>
import PhotoModal from './PhotoModal.vue'
export default {
  props: {
    items: Array
  },
  data() {
    return {
      showPhotoId: null
    }
  },
  components: { PhotoModal },
  methods: {
    // showPhotoModal(photoId) {
    //   console.log(`show photo with id ${photoId}`)
    // },
  },
  mounted() {
    console.log(this.items)
    console.log(this.showPhotoId)
  }
}
</script>